import { useExperiment } from '@coursera-web/statsig';

import { useIsLohp } from 'bundles/collections-common/utils/useIsLohp';
import useIsConsumerSerp from 'bundles/search-common/utils/useIsConsumerSerp';

const EXPERIMENT_NAME = 'two_panel_search';
const PARAM_NAME = 'enable_search_ai';

/**
 * Two-panel SERP assignment with exposure logging. Treatment is delivered on
 * both the consumer SERP and LOHP (frontpage entry point), so exposure logs
 * at either surface — matches the impression point convention used by the
 * preceding "AI Search on LOHP" experiment.
 */
export const useTwoPanelSearchExperiment = (): boolean => {
  const isConsumerSerp = useIsConsumerSerp();
  const isLohp = useIsLohp();
  const shouldExpose = isConsumerSerp || isLohp;
  const experiment = useExperiment(EXPERIMENT_NAME, { disableExposureLog: !shouldExpose });
  if (!shouldExpose) {
    return false;
  }
  return experiment.get(PARAM_NAME, false);
};
